export default __webpack_public_path__ + "assets/nasa-logo.cdf6a928.png";